export default "__VITE_ASSET__AUxlxIXS__"